import {
    SpaceBetween,
    Header,
    Box,
    Button,
    ExpandableSection,
    ColumnLayout,
    StatusIndicator,
} from '@amzn/awsui-components-console';
import React, { useEffect, useState } from 'react';
import * as Constants from './constants';

/**
 * empty state of the table
 */
export function EmptyState({ title, subtitle, action }) {
    return (
        <Box textAlign="center" color="inherit">
            <Box variant="strong" textAlign="center" color="inherit">
                {title}
            </Box>
            <Box variant="p" padding={{ bottom: 's' }} color="inherit">
                {subtitle}
            </Box>
            {action}
        </Box>
    );
}

/**
 * get filtered item count
 * @param {*} filteredItemsCount
 * @returns
 */
export function getFilterCounterText(filteredItemsCount) {
    if (filteredItemsCount <= 1) {
        return `${filteredItemsCount} match`;
    } else {
        return `${filteredItemsCount} matches`;
    }
}

/**
 * get a label component with value
 * @param {*} label
 * @param {*} value
 * @returns
 */
export function getValueWithLabel(label, value) {
    return (
        <div key={label}>
            <Box variant="awsui-key-label">{label}</Box>
            <div>{value}</div>
        </div>
    );
}

/**
 * get custom config item status, enabled or disabled
 * @param {*} enabled
 * @returns
 */
function getItemStatus(enabled) {
    if (!enabled) {
        return <StatusIndicator type="stopped">Disabled</StatusIndicator>;
    } else {
        return <StatusIndicator type="success">Enabled</StatusIndicator>;
    }
}

/**
 * for each subsection of custom config, get a component
 * @param {*} name
 * @param {*} config
 * @param {*} items
 * @returns
 */
const getSubsectionConfigComponents = (name, config, items) => {
    const defaultValue = name == Constants.GROUP_CONFIG_KEYS.widgets ? true : false;
    if (!config) {
        return items.map((item) => getValueWithLabel(`${name}/${item}`, getItemStatus(defaultValue)));
    } else if (config.length == 0) {
        return items.map((item) => getValueWithLabel(`${name}/${item}`, getItemStatus(false)));
    } else {
        return items.map((item) =>
            config.includes(item)
                ? getValueWithLabel(`${name}/${item}`, getItemStatus(true))
                : getValueWithLabel(`${name}/${item}`, getItemStatus(false))
        );
    }
};

/**
 * get a component of custom config
 * @param {*} config
 * @returns
 */
export const getCustomConfig = (config) => {
    const widgetsComponents = getSubsectionConfigComponents(
        Constants.GROUP_CONFIG_KEYS.widgets,
        config[Constants.GROUP_CONFIG_KEYS.widgets],
        Constants.WIDGETS
    );
    const teardownComponents = getSubsectionConfigComponents(
        Constants.GROUP_CONFIG_KEYS.teardown,
        config[Constants.GROUP_CONFIG_KEYS.teardown],
        Constants.TEARDOWN
    );
    const setupComponents = getSubsectionConfigComponents(
        Constants.GROUP_CONFIG_KEYS.setup,
        config[Constants.GROUP_CONFIG_KEYS.setup],
        Constants.SETUP
    );
    const widgetsMidIndex = Math.round(widgetsComponents.length / 2);
    return (
        <ExpandableSection headerText="See details">
            <ColumnLayout columns={4} variant="text-grid">
                <SpaceBetween size="s">{widgetsComponents.slice(0, widgetsMidIndex)}</SpaceBetween>
                <SpaceBetween size="s">
                    {widgetsComponents.slice(widgetsMidIndex, widgetsComponents.length)}
                </SpaceBetween>
                <SpaceBetween size="s">
                    {teardownComponents}
                    {setupComponents}
                </SpaceBetween>
            </ColumnLayout>
        </ExpandableSection>
    );
};
